import { isJobPlatformPath } from '~/utils/storefrontHost'

/**
 * `{shop}.vntru.com` is the storefront only — never the Wazzafni / job app.
 *
 * Logged-in owners share the auth cookie across the apex, so without this they
 * used to land on `/app/home` when opening their own shop subdomain.
 */
export default defineNuxtRouteMiddleware((to) => {
  if (!currentStoreSubdomain()) return
  if (!isJobPlatformPath(to.path)) return
  return navigateTo('/', { replace: true })
})
